module.exports = __webpack_public_path__ + "media/magnifying-glass-green.8954a03e.svg";